import { jsx } from "react/jsx-runtime";
import AlertTriangle from "@crehana/compass.icons.fill/AlertTriangle";
import CheckmarkCircle from "@crehana/compass.icons.fill/CheckmarkCircle";
import CloseCircle from "@crehana/compass.icons.fill/CloseCircle";
import Info from "@crehana/compass.icons.fill/Info";
const ToastIcon = ({ type })=>{
    switch(type){
        case 'informative':
            return /*#__PURE__*/ jsx(Info, {
                size: 20,
                className: "tw-text-info-500 dark:tw-text-info-300"
            });
        case 'success':
            return /*#__PURE__*/ jsx(CheckmarkCircle, {
                size: 20,
                className: "tw-text-success-500 dark:tw-text-success-400"
            });
        case 'warning':
            return /*#__PURE__*/ jsx(AlertTriangle, {
                size: 20,
                className: "tw-text-on-hold-500 dark:tw-text-on-hold-300"
            });
        case 'error':
            return /*#__PURE__*/ jsx(CloseCircle, {
                size: 20,
                className: "tw-text-alert-500 dark:tw-text-alert-300"
            });
        default:
            return null;
    }
};
export { ToastIcon };
